module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Maps"
    }
  }, [_c('p', {
    staticClass: "map-title"
  }, [_vm._v("Maps")]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter03#map_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(Map) Route of U-6 15 through the Caribbean")])]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter06#map_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(Map) U-Boat Losses in the South Atlantic")])]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter06#map_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(Map) U-Boat Losses in the Indian Ocean")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ca40e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Maps.vue
// module id = 72
// module chunks = 0